import { useMemo } from 'react';

import type { UseChatSettingsResult } from './use-chat-settings';

export function useMailboxPayload(
  settings: Pick<UseChatSettingsResult, 'groups' | 'selectedGroupIds' | 'sharedInboxes'>,
) {
  const { groups, selectedGroupIds, sharedInboxes } = settings;

  const mailboxGroups = useMemo(
    () =>
      groups
        .filter((group) => selectedGroupIds.has(group.id))
        .map((group) => ({ id: group.id, name: group.displayName })),
    [groups, selectedGroupIds],
  );

  const sharedMailboxIds = useMemo(
    () => sharedInboxes.filter((inbox) => inbox.enabled).map((inbox) => inbox.email),
    [sharedInboxes],
  );

  return {
    mailboxGroups: mailboxGroups.length > 0 ? mailboxGroups : null,
    sharedMailboxIds: sharedMailboxIds.length > 0 ? sharedMailboxIds : null,
  };
}
